/*
 *		Copyright (c) 2011-2022 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('accessWebClient')
    .controller('UploadRequestCreateUpdateModalController', [
        '$filter',
        '$modalInstance',
        '$scope',
        'isEdit',
        'target',
        'uploadRequest',
        'UploadRequest',
        'UploadRequestInterceptor',
        'DateTools',
        function (
            $filter,
            $modalInstance,
            $scope,
            isEdit,
            target,
            uploadRequest,
            UploadRequestResource,
            UploadRequestInterceptor,
            DateTools
        ) {
            var MIN_EXPIRATION_DATE = DateTools.addDays(new Date, 1);
            var MAX_EXPIRATION_DATE = DateTools.addDays(new Date, 60);

            $scope.uploadRequest = isEdit ? uploadRequest : _createEmptyUploadRequest(target);
            $scope.modal = $modalInstance.options;
            $scope.formData = {
                limitMaxFiles: $scope.uploadRequest.hasFilesCountLimit,
                maxFiles: $scope.uploadRequest.max_file_count || 1,
                limitMaxSize: $scope.uploadRequest.hasFileSizeLimit,
                maxFileSizeInMB: parseFloat(($scope.uploadRequest.max_file_size / 1048576 || 1).toFixed(2)),
                limitExtensions: $scope.uploadRequest.hasAllowedExtension,
                targetPath: target.getFullPath()
            };
            $scope.isSubmitting = false;

            $scope.isExpirationDateCalendarOpened = false;
            $scope.expirationMinDate = MIN_EXPIRATION_DATE;
            $scope.expirationMaxDate = MAX_EXPIRATION_DATE;

            $scope.close = $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };

            $scope.setLanguage = function (lang) {
                $scope.uploadRequest.locale = lang.id;
            };

            $scope.onFormSubmit = function () {
                if (
                    $scope.isSubmitting ||
                    $scope.formData.limitMaxFiles && !$scope.formData.maxFiles ||
                    $scope.formData.limitMaxSize && !$scope.formData.maxFileSizeInMB ||
                    $scope.formData.limitExtensions && !$scope.uploadRequest.allowed_file_extensions.length
                ) {
                    return;
                }

                $scope.uploadRequest.max_file_count = $scope.formData.limitMaxFiles ? $scope.formData.maxFiles : null;
                $scope.uploadRequest.max_file_size = $scope.formData.limitMaxSize ? $scope.formData.maxFileSizeInMB * 1048576 : null;

                if (!$scope.formData.limitExtensions) {
                    $scope.uploadRequest.allowed_file_extensions = [];
                }

                if ($scope.uploadRequest.expiration_date instanceof Date) {
                    $scope.uploadRequest.expiration_date = $filter('date')(
                        $scope.uploadRequest.expiration_date,
                        'yyyy-MM-dd'
                    );
                }

                var request = isEdit ? UploadRequestResource.update : UploadRequestResource.create;

                $scope.isSubmitting = true;

                return request($scope.uploadRequest).$promise
                    .then($modalInstance.close)
                    .finally(function () {
                        $scope.isSubmitting = false;
                    });
            };

            $scope.submitButtonLabel = function () {
                return isEdit ?
                    'upload_requests_requested_files_actions_edit_update_button' :
                    'upload_requests_upload_modal_send_button'
            };

            function _createEmptyUploadRequest(target) {
                var WEEK_AFTER_DATE = Date.now() + 7 * 86400000;

                return UploadRequestInterceptor.response({
                    resource: {
                        access_restriction: 'public',
                        allowed_file_extensions: [],
                        expiration_date: $filter('date')(WEEK_AFTER_DATE, 'yyyy-MM-dd'),
                        max_file_count: null,
                        max_file_size: null,
                        node: target
                    }
                });
            }
        }
    ]);
